// components/PdfExportTable.js
import React from 'react';
import { Table } from 'antd';
import dayjs from 'dayjs';

const PdfExportTable = React.forwardRef(({ 
  title, 
  subtitle, 
  columns, 
  data, 
  totales,
  type 
}, ref) => {
  
  // Formatear datos para PDF
  const formatDataForPDF = () => {
    const formattedData = data.map(item => {
      const newItem = { ...item };
      
      // Formatear fecha
      if (newItem.Fecha) {
        newItem.Fecha = dayjs(newItem.Fecha).format('DD/MM/YYYY');
      }
      
      return newItem;
    });
    
    // Añadir fila de totales si existe
    if (totales && type === 'servicioCocina') {
      formattedData.push({
        key: 'totales',
        Fecha: 'TOTALES',
        Desayuno: totales.Desayuno,
        PicnicD: totales.PicnicD,
        TotalD: totales.TotalD,
        Almuerzo: totales.Almuerzo,
        PicnicA: totales.PicnicA,
        TotalA: totales.TotalA,
        Cena: totales.Cena,
        PicnicC: totales.PicnicC,
        TotalC: totales.TotalC,
        TodoIncluido: totales.TodoIncluido,
        Observaciones: ''
      });
    }
    
    if (totales && type === 'nacionalidad') {
      formattedData.push({
        key: 'totales',
        Fecha: 'TOTALES',
        Nacionalidad: '',
        Desayuno: totales.Desayuno,
        Almuerzo: totales.Almuerzo,
        Cena: totales.Cena,
        PicnicD: totales.PicnicD,
        PicnicA: totales.PicnicA,
        PicnicC: totales.PicnicC,
        TodoIncluido: totales.TodoIncluido
      });
    }
    
    return formattedData;
  };
  
  // Columnas para servicio cocina
  const servicioCocinaColumns = [
    { title: 'Fecha', dataIndex: 'Fecha', key: 'Fecha', width: 100 },
    { title: 'Desayuno', dataIndex: 'Desayuno', key: 'Desayuno', width: 80, align: 'center' },
    { title: 'Picnic D', dataIndex: 'PicnicD', key: 'PicnicD', width: 80, align: 'center' },
    { title: 'Total D', dataIndex: 'TotalD', key: 'TotalD', width: 80, align: 'center' },
    { title: 'Almuerzo', dataIndex: 'Almuerzo', key: 'Almuerzo', width: 80, align: 'center' },
    { title: 'Picnic A', dataIndex: 'PicnicA', key: 'PicnicA', width: 80, align: 'center' },
    { title: 'Total A', dataIndex: 'TotalA', key: 'TotalA', width: 80, align: 'center' },
    { title: 'Cena', dataIndex: 'Cena', key: 'Cena', width: 80, align: 'center' },
    { title: 'Picnic C', dataIndex: 'PicnicC', key: 'PicnicC', width: 80, align: 'center' },
    { title: 'Total C', dataIndex: 'TotalC', key: 'TotalC', width: 80, align: 'center' },
    { title: 'Todo Incluido', dataIndex: 'TodoIncluido', key: 'TodoIncluido', width: 100, align: 'center' },
    { title: 'Observaciones', dataIndex: 'Observaciones', key: 'Observaciones', width: 150 }
  ];
  
  // Columnas para nacionalidad
  const nacionalidadColumns = [
    { title: 'Fecha', dataIndex: 'Fecha', key: 'Fecha', width: 100 },
    { title: 'Nacionalidad', dataIndex: 'Nacionalidad', key: 'Nacionalidad', width: 150 },
    { title: 'Desayuno', dataIndex: 'Desayuno', key: 'Desayuno', width: 80, align: 'center' },
    { title: 'Almuerzo', dataIndex: 'Almuerzo', key: 'Almuerzo', width: 80, align: 'center' },
    { title: 'Cena', dataIndex: 'Cena', key: 'Cena', width: 80, align: 'center' },
    { title: 'Picnic D', dataIndex: 'PicnicD', key: 'PicnicD', width: 80, align: 'center' },
    { title: 'Picnic A', dataIndex: 'PicnicA', key: 'PicnicA', width: 80, align: 'center' },
    { title: 'Picnic C', dataIndex: 'PicnicC', key: 'PicnicC', width: 80, align: 'center' },
    { title: 'Todo Incluido', dataIndex: 'TodoIncluido', key: 'TodoIncluido', width: 100, align: 'center' }
  ];
  
  const selectedColumns = type === 'servicioCocina' ? servicioCocinaColumns : nacionalidadColumns;
  const tableData = formatDataForPDF();
  
  // Estilos para impresión
  const printStyles = {
    container: {
      padding: '20px',
      fontFamily: 'Arial, sans-serif',
      backgroundColor: 'white'
    },
    title: {
      textAlign: 'center',
      marginBottom: '10px',
      fontSize: '24px',
      fontWeight: 'bold'
    },
    subtitle: {
      textAlign: 'center',
      marginBottom: '5px',
      fontSize: '14px',
      color: '#666'
    },
    date: {
      textAlign: 'center',
      marginBottom: '20px',
      fontSize: '12px',
      color: '#999'
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      fontSize: '11px'
    },
    th: {
      border: '1px solid #ddd',
      padding: '8px',
      backgroundColor: '#1890ff',
      color: 'white',
      fontWeight: 'bold',
      textAlign: 'center'
    },
    td: {
      border: '1px solid #ddd',
      padding: '6px',
      textAlign: 'center'
    }
  };
  
  return (
    <div ref={ref} style={printStyles.container}>
      <h1 style={printStyles.title}>{title}</h1>
      <div style={printStyles.subtitle}>{subtitle}</div>
      <div style={printStyles.date}>Generado: {dayjs().format('DD/MM/YYYY HH:mm:ss')}</div>
      
      <table style={printStyles.table}>
        <thead>
          <tr>
            {selectedColumns.map(col => (
              <th key={col.key} style={printStyles.th}>
                {col.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableData.map((row, idx) => (
            <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#f5f5f5' }}>
              {selectedColumns.map(col => (
                <td key={col.key} style={printStyles.td}>
                  {row[col.dataIndex] || '-'}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
});

PdfExportTable.displayName = 'PdfExportTable';

export default PdfExportTable;